module.exports = __webpack_public_path__ + "img/footer-background.b5c5626f.jpg";